export default {
  TEXT: 'text',
  TOGGLE: 'toggle',
  CHECKBOX: 'checkbox',
  PASSWORD: 'password',
  DROPDOWN: 'dropdown',
  DATE_PICKER: 'datepicker',
  AUTOCOMPLETE: 'autocomplete'
};